import React from "react";
import { observer } from "mobx-react";

import LoyaltyIcon from "@material-ui/icons/Loyalty";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import FitnessCenterIcon from "@material-ui/icons/FitnessCenter";
import AssignmentIcon from "@material-ui/icons/Assignment";
import PeopleIcon from "@material-ui/icons/People";
import AccessibilityIcon from "@material-ui/icons/Accessibility";

import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@material-ui/core";

import SvgI24Today from "assets/icons/I24Today";
import SvgI24Nutrition from "assets/icons/I24Nutrition";
import SvgI24Resources from "assets/icons/I24Resources";
import SvgI24Studio from "assets/icons/I24Studio";
import SvgI24Users from "assets/icons/I24Users";
import SvgI24Logout from "assets/icons/I24Logout";
import SvgI24Filter from "assets/icons/I24Filter";
import SvgI24Exclamation from "assets/icons/I24Exclamation";
import SvgI24HealthCondition from "assets/icons/I24HealthCondition";
import SvgI24Restriction from "assets/icons/I24Restriction";
import SvgI24ManualBadge from "assets/icons/I24ManualBadge";

import NavMenu from "components/NavMenu";

import ROUTES from "navigation/routes";

import {
  Divider,
  Image,
  AdminInfo,
  SidebarContent,
  SidebarGap,
  TopBar,
  TopBarContent,
  Drawer,
  Footer,
} from "./styles";

type Props = {
  match: any;
  user: any;
  onLogout: () => void;
};

const SIDEBAR_ITEMS_IN_APP = [
  {
    title: "Today",
    icon: <SvgI24Today />,
    route: ROUTES.IN_APP_TODAY,
    rootRoute: ROUTES.IN_APP_TODAY,
  },
  {
    title: "Nutrition",
    icon: <SvgI24Nutrition />,
    route: ROUTES.IN_APP_NUTRITION,
    rootRoute: ROUTES.IN_APP_NUTRITION,
  },
  { title: "Studio", icon: <SvgI24Studio />, route: ROUTES.IN_APP_STUDIO },
  {
    title: "Resources",
    icon: <SvgI24Resources />,
    route: ROUTES.IN_APP_RESOURCES,
    rootRoute: ROUTES.IN_APP_RESOURCES,
  },
  {
    title: "Workout Sequences",
    icon: <AccessibilityIcon />,
    route: ROUTES.IN_APP_WORKOUT_SEQUENCES,
    rootRoute: ROUTES.IN_APP_WORKOUT_SEQUENCES,
  },
  {
    title: "Manual Badges",
    icon: <SvgI24ManualBadge />,
    route: ROUTES.IN_APP_MANUAL_BADGES,
    rootRoute: ROUTES.IN_APP_MANUAL_BADGES,
  },
];

const SIDEBAR_ITEMS_CONTENT = [
  {
    title: "Nutrition",
    icon: <SvgI24Nutrition />,
    route: ROUTES.CONTENT_NUTRITION,
    rootRoute: ROUTES.CONTENT_NUTRITION,
  },
  {
    title: "Studio",
    icon: <SvgI24Studio />,
    route: ROUTES.CONTENT_STUDIO,
    rootRoute: ROUTES.CONTENT_STUDIO,
  },
  {
    title: "Resources",
    icon: <SvgI24Resources />,
    route: ROUTES.CONTENT_RESOURCES,
    rootRoute: ROUTES.CONTENT_RESOURCES,
  },
  {
    title: "Special Programs",
    icon: <AssignmentIcon />,
    route: ROUTES.CONTENT_CONTENT_COLLECTIONS,
    rootRoute: ROUTES.CONTENT_CONTENT_COLLECTIONS,
  },
  {
    title: "Active Program",
    icon: <AssignmentIcon />,
    route: ROUTES.CONTENT_ACTIVE_PROGRAM,
    rootRoute: ROUTES.CONTENT_ACTIVE_PROGRAM,
  },
  {
    title: "Greetings",
    icon: <AssignmentIcon />,
    route: ROUTES.CONTENT_GREETINGS,
    rootRoute: ROUTES.CONTENT_GREETINGS,
  },
  {
    title: "Target Zones",
    icon: <AccessibilityIcon />,
    route: ROUTES.CONTENT_TARGET_ZONES,
    rootRoute: ROUTES.CONTENT_TARGET_ZONES,
  },
  {
    title: "Trainers",
    icon: <AccessibilityIcon />,
    route: ROUTES.CONTENT_TRAINERS,
    rootRoute: ROUTES.CONTENT_TRAINERS,
  },
  {
    title: "Tags",
    icon: <LoyaltyIcon />,
    route: ROUTES.CONTENT_TAGS,
    rootRoute: ROUTES.CONTENT_TAGS,
  },
  {
    title: "Questionnaire",
    icon: <QuestionAnswerIcon />,
    route: ROUTES.CONTENT_QUESTIONNAIRE,
    rootRoute: ROUTES.CONTENT_QUESTIONNAIRE,
  },
  {
    title: "Pattern",
    icon: <SvgI24Filter />,
    route: ROUTES.CONTENT_PATTERNS_PATTERNS,
    rootRoute: ROUTES.CONTENT_PATTERNS_PATTERNS,
  },
  {
    title: "Claims",
    icon: <SvgI24Exclamation />,
    route: ROUTES.CONTENT_CLAIMS,
    rootRoute: ROUTES.CONTENT_CLAIMS,
  },
  {
    title: "Restrictions",
    icon: <SvgI24Restriction width="100%" />,
    route: ROUTES.CONTENT_RESTRICTION,
    rootRoute: ROUTES.CONTENT_RESTRICTION,
  },
  {
    title: "Health Condition",
    icon: <SvgI24HealthCondition />,
    route: ROUTES.CONTENT_HEALTH_CONDITION,
    rootRoute: ROUTES.CONTENT_HEALTH_CONDITION,
  },
  {
    title: "Tips",
    icon: <SvgI24Resources />, // TODO: change this
    route: ROUTES.CONTENT_TIPS,
    rootRoute: ROUTES.CONTENT_TIPS,
  },
  {
    title: "Coaches",
    icon: <FitnessCenterIcon />,
    route: ROUTES.CONTENT_PERSONAL,
    rootRoute: ROUTES.CONTENT_PERSONAL,
  },
  {
    title: "Profiles",
    icon: <PeopleIcon />,
    route: ROUTES.CONTENT_PROFILE,
    rootRoute: ROUTES.CONTENT_PROFILE,
  },
  {
    title: "Trivia",
    icon: <QuestionAnswerIcon />,
    route: ROUTES.CONTENT_TRIVIA,
    rootRoute: ROUTES.CONTENT_TRIVIA,
  },
];

const SIDEBAR_ITEMS_SETTINGS = [
  {
    title: "Users",
    icon: <SvgI24Users />,
    route: ROUTES.SETTINGS_USERS,
    rootRoute: ROUTES.SETTINGS_USERS,
  },
];

@observer
class Sidebar extends React.Component<Props> {
  render() {
    const { user, match, onLogout } = this.props;

    return (
      <React.Fragment>
        <SidebarGap />
        <Drawer>
          <SidebarContent>
            <TopBar>
              <TopBarContent>
                <Image />
                <AdminInfo>
                  <Typography variant="h4" noWrap>
                    {user?.fullName ?? "FASTer Way"}
                  </Typography>
                </AdminInfo>
              </TopBarContent>
            </TopBar>

            <Divider light />

            <NavMenu
              items={SIDEBAR_ITEMS_IN_APP}
              match={match}
              subheader={"In App"}
            />

            <Divider light />

            <NavMenu
              items={SIDEBAR_ITEMS_CONTENT}
              match={match}
              subheader={"Content"}
            />

            <Divider light />

            <NavMenu
              items={SIDEBAR_ITEMS_SETTINGS}
              match={match}
              subheader={"Settings"}
            />

            <Footer>
              <ListItem onClick={onLogout}>
                <ListItemIcon>
                  <SvgI24Logout />
                </ListItemIcon>
                <ListItemText primary="Log Out" />
              </ListItem>
            </Footer>
          </SidebarContent>
        </Drawer>
      </React.Fragment>
    );
  }
}

export default Sidebar;
